<div class="occ-public-page">
  <div class="container py-5" style="max-width: 640px;">
    <div class="text-center mb-4">
      <span class="brand-badge">🔎</span>
      <h1 class="h2 mt-3 mb-1">Acompanhar ocorrência</h1>
      <p class="text-muted mb-0">
        Introduza o código que recebeu ao registar — o estado é consultável sem revelar quem participou.
        <br />Ainda não registou? <a [routerLink]="['/', tenant, 'participar']">Registar ocorrência</a>.
      </p>
    </div>

    @if (fromChannel) {
      <a class="btn btn-sm btn-white mb-3" [routerLink]="['/', tenant, 'canal-denuncias']">
        <i class="fe fe-arrow-left me-1"></i> Voltar
      </a>
    }

    <div class="card">
      <div class="card-body">
        <label class="form-label">Código de acompanhamento</label>
        <div class="d-flex gap-2">
          <input class="form-control" [(ngModel)]="code" placeholder="Ex.: A2B3-C4D5" (keyup.enter)="lookup()" />
          <button class="btn btn-primary" (click)="lookup()" [disabled]="loading()">
            {{ loading() ? 'A consultar…' : 'Consultar' }}
          </button>
        </div>
        @if (error()) { <div class="alert alert-danger mt-3 mb-0">{{ error() }}</div> }
      </div>
    </div>

    @if (status(); as info) {
      <div class="card">
        <div class="card-body">
          <!-- O que quem comunicou vê, situação a situação (revisão de 2026-10-15). Mostrava as
               etapas internas do tratamento e, sem desfecho, o resultado do fecho — que é texto
               da equipa. -->
          <div class="row g-3 mb-4">
            <div class="col-sm-4">
              <span class="occ-date-label d-block">Estado</span>
              <span class="fw-bold">{{ situationLabels[info.situation] }}</span>
            </div>
            <div class="col-sm-4">
              <span class="occ-date-label d-block">Registada em</span>
              <span class="fw-bold">{{ info.createdAt | date: 'dd/MM/yyyy' }}</span>
            </div>
            @if (closed()) {
              <div class="col-sm-4">
                <span class="occ-date-label d-block">Data de conclusão</span>
                <span class="fw-bold">{{ (info.closingDate | date: 'dd/MM/yyyy') || '—' }}</span>
              </div>
            }
          </div>

          <!-- Resultado da triagem: por decidir, à espera de elementos (com a data do pedido), aceite
               (com a data em que a análise concluiu) ou não aceite. Fechada sem triagem registada
               não diz "por decidir" — já não está a ser analisada. -->
          @if (info.triageApplies && (!closed() || info.triageResult)) {
            <div class="alert border mb-4" [class.alert-light]="!info.awaitingElements || info.triageResult"
                 [class.alert-warning]="info.awaitingElements && !info.triageResult">
              <h6 class="text-muted text-uppercase mb-2"><i class="fe fe-filter me-1"></i> Resultado da triagem</h6>
              <p class="mb-0">
                @if (info.triageResult) {
                  <strong>{{ triageResultLabels[info.triageResult] }}</strong>
                  @if (info.triageDecidedAt) {
                    <span class="text-muted"> · {{ info.triageDecidedAt | date: 'dd/MM/yyyy' }}</span>
                  }
                } @else if (info.awaitingElements) {
                  <strong>Aguarda elementos</strong>
                  @if (info.elementsRequestedAt) {
                    <span class="text-muted"> · pedidos em {{ info.elementsRequestedAt | date: 'dd/MM/yyyy' }}</span>
                  }
                  <span class="d-block small mt-1">Responda pela caixa de mensagens abaixo.</span>
                } @else {
                  <strong>Por decidir</strong>
                  <span class="text-muted"> · a participação está a ser analisada.</span>
                }
              </p>
            </div>
          }

          <!-- Fechada: o tipo de fecho só quando foi na análise; o desfecho pelo nome, ou, quando é
               "Outro", a descrição dele — que é onde ele foi escrito. -->
          @if (closed()) {
            <div class="alert alert-light border mb-0">
              @if (info.closingType === 'FECHADO_APOS_ANALISE') {
                <h6 class="text-muted text-uppercase mb-1">Tipo de fecho</h6>
                <p class="mb-3"><strong>{{ closingTypeLabels['FECHADO_APOS_ANALISE'] }}</strong></p>
              }
              <h6 class="text-muted text-uppercase mb-1"><i class="fe fe-check-square me-1"></i> Desfecho</h6>
              @if (info.outcome === 'OUTRO') {
                <p class="mb-0" style="white-space: pre-wrap;">{{ info.closingResult || '—' }}</p>
              } @else if (info.outcome) {
                <p class="mb-0"><strong>{{ outcomeLabels[info.outcome] }}</strong></p>
              } @else {
                <p class="mb-0 text-muted">—</p>
              }
            </div>
          }
        </div>
      </div>

      <!-- Pedido de elementos adicionais: a equipa escreve aqui e a resposta volta com o
           identificador, sem quem participou ter de se identificar. -->
      @if (info.messages.length || !closed()) {
        <div class="card">
          <div class="card-body">
            <h6 class="text-muted text-uppercase mb-3"><i class="fe fe-message-square me-1"></i> Mensagens</h6>
            @if (info.messages.length === 0) {
              <p class="text-muted">
                Ainda não há mensagens. Se precisarmos de mais elementos, pedimo-los por aqui —
                basta voltar com o mesmo identificador.
              </p>
            } @else {
              @for (message of info.messages; track message.sentAt) {
                <!-- As nossas à esquerda, as suas à direita: percebe-se de quem é sem nomes. -->
                <div class="d-flex mb-3" [class.justify-content-end]="!message.fromUs">
                  <div class="p-3 rounded" style="max-width: 85%;"
                       [class.bg-light]="message.fromUs"
                       [class.bg-primary-soft]="!message.fromUs">
                    <p class="mb-1 occ-prewrap">{{ message.body }}</p>
                    <span class="small text-muted">
                      {{ message.fromUs ? 'Equipa' : 'Você' }} · {{ message.sentAt | date: 'dd/MM/yyyy HH:mm' }}
                    </span>
                  </div>
                </div>
              }
            }

            @if (closed()) {
              <div class="alert alert-secondary mb-0">
                A ocorrência foi fechada, por isso a conversa está encerrada.
              </div>
            } @else {
              <label class="form-label">A sua resposta</label>
              <textarea class="form-control" rows="4" [(ngModel)]="reply"
                        placeholder="Escreva aqui o que quer acrescentar."></textarea>
              <!-- Anexar: é por aqui que chegam os elementos adicionais que a equipa pediu. -->
              <div class="mt-2">
                <!-- O input de ficheiro nativo mostra "Choose File / No file chosen" em inglês,
                     numa página que é para o público e está toda em português. O botão é um
                     <label> com o input escondido lá dentro: o browser não escreve nada. -->
                <label class="btn btn-sm btn-white mb-0">
                  <i class="fe fe-paperclip me-1"></i>Juntar um ficheiro
                  <input type="file" hidden (change)="pickFile($event)" />
                </label>
                <span class="small text-muted ms-2">opcional, até 10 MB</span>
                @if (attachment) {
                  <span class="small d-block mt-2">
                    <i class="fe fe-file me-1"></i>{{ attachment.name }}
                  </span>
                }
              </div>
              @if (replyError()) { <div class="alert alert-danger mt-3 mb-0">{{ replyError() }}</div> }
              @if (sent()) { <div class="alert alert-success mt-3 mb-0">Mensagem enviada. Obrigado.</div> }
              <div class="d-flex justify-content-end mt-3">
                <button class="btn btn-primary" (click)="send()" [disabled]="sending() || !reply.trim()">
                  {{ sending() ? 'A enviar…' : 'Enviar' }}
                </button>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
